import { formatTime, zonedParts } from '@obv/core';
import { useWeather } from '@/queries/hooks';
import { useDisplay } from '../context';
import { Pill } from '../ui';

const STALE_MS = 60 * 60_000;
const DEAD_MS = 6 * 60 * 60_000;

/** Weather for the display, with the household-local "Updated hh:mm" and stale/dead thresholds. */
export function useWeatherState() {
  const ctx = useDisplay();
  const q = useWeather();
  const w = q.data;
  const age = w ? ctx.clock.now.getTime() - new Date(w.fetched_at).getTime() : Infinity;
  const usable = !!w && age < DEAD_MS;
  const updated = w ? formatTime(zonedParts(new Date(w.fetched_at), ctx.tz).hhmm, ctx.prefs.h24) : null;
  return { q, w: usable ? w : undefined, stale: age > STALE_MS, updated, pending: q.isLoading || (q.error && q.error.code === 'weather.pending') };
}

export function UpdatedPill() {
  const ctx = useDisplay();
  const { updated, stale } = useWeatherState();
  if (!ctx.online) return <Pill tone="warn">{updated ? `Offline · data from ${updated}` : 'Offline'}</Pill>;
  if (!updated) return <Pill>Waiting for weather…</Pill>;
  return <Pill tone={stale ? 'warn' : 'default'}>Updated {updated}</Pill>;
}
